import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-action';
import '../../common/bn-load-more-button';
import './work-order-card';

class WorkOrderGrid extends LitEntity {
  constructor() {
    super();
    this.filterActions = [];
    this.workOrders = [];
  }

  static get properties() {
    return {
      isFetching: { type: Boolean, attribute: false },
      filterActions: { type: Array, attribute: false },
      workOrders: { type: Array, attribute: false },
      hideAddress: { type: Boolean, attribute: 'hide-address' },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .actions {
        text-align: right;
        display: flex;
        justify-content: flex-end;
      }
      .actions bn-action {
        margin: 8px;
      }
      .work-orders {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
      }
      .no-data {
        text-align: center;
        padding: 1em;
      }
    `];
  }

  renderEntity() {
    if (!this.workOrders.length) {
      return html`
        <slot name="no-data"><div class="no-data">No work orders to display</div></slot>
      `;
    }
    return html`
      <div class="work-orders">
        ${this.workOrders.map((workOrder) => html`
          <work-order-card
            .href="${workOrder.getLink('self').href}"
            ?hide-address="${this.hideAddress}"
          ></work-order-card>
        `)}
        ${renderIf(this.loading, () => html`<bn-loading></bn-loading>`)}
      </div>
      <bn-load-more-button
        .href="${this.href}"
        @moreloaded="${this._onMoreLoaded}"
      ></bn-load-more-button>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.workOrders = (this.entity && this.entity.getSubEntitiesByClass('work-order')) || [];
    this.filterActions = (this.entity && this.entity.getActionsByClass('filter')) || [];
  }

  _onResponse() {
    entityStore.invalidateHref(this.href);
  }

  async _filter(action) {
    this.href = action.href;
  }

  async _onMoreLoaded(e) {
    const { entity } = e.detail;
    this.workOrders = [...this.workOrders, ...entity.getSubEntitiesByClass('work-order')];
  }
}

customElements.define('work-order-grid', WorkOrderGrid);
